import { createRoute, redirect } from '@tanstack/react-router'
import { authenticatedRoute } from '../_authenticated'

// Post route redirects to feed with post modal open
export const postRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/posts/$urlKey',
  beforeLoad: ({ params }) => {
    // Redirect to feed with post param to open the post modal
    throw redirect({
      to: '/feed',
      search: { post: params.urlKey },
    })
  },
  component: () => null, // Never renders due to redirect
})
